import { getCoreAcademicNamespace, useCoreAcademicNamespace } from '../api';
import { EmulateHeaders } from '../utils';

function getActiveAcademicNamespace(
  data: ReturnType<typeof useCoreAcademicNamespace>['data'],
) {
  const emulationNamespace = localStorage.getItem(
    EmulateHeaders.ACADEMIC_NAMESPACE_ID,
  );

  return data?.find((namespace) =>
    emulationNamespace
      ? namespace.academicNamespaceId === Number(emulationNamespace)
      : namespace?.isActiveDefaultNamespace,
  );
}

function getDefaultAcademicNamespace(
  data: ReturnType<typeof useCoreAcademicNamespace>['data'],
) {
  return data?.find((namespace) => namespace?.isActiveDefaultNamespace);
}

export async function getAcademicNamespace() {
  const { core_academicNamespaces: data } = await getCoreAcademicNamespace();
  const activeAcademicNamespace = getActiveAcademicNamespace(data);
  const defaultActiveAcademicNamespace = getDefaultAcademicNamespace(data);

  return {
    activeAcademicNamespace,
    defaultActiveAcademicNamespace,
    allNamespaces: data,
  };
}

export function useAcademicNamespace() {
  const { data, ...rest } = useCoreAcademicNamespace();
  const activeAcademicNamespace = getActiveAcademicNamespace(data);
  const defaultActiveAcademicNamespace = getDefaultAcademicNamespace(data);

  return {
    activeAcademicNamespace,
    defaultActiveAcademicNamespace,
    allNamespaces: data,
    ...rest,
  };
}

export async function resolveNamespaceId(
  namespaceId: number | null | undefined,
) {
  if (namespaceId) return namespaceId;

  const { activeAcademicNamespace } = await getAcademicNamespace();
  return activeAcademicNamespace?.academicNamespaceId ?? 0;
}

export type ReturnTypeFromUseAcademicNamespace = ReturnType<
  typeof useAcademicNamespace
>;
